import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { getRecipientList } from "../../../../services/Recipients";
import Utils from "../../../../utils";

function SearchRecipient(props) {
  const [recipientOptions, setRecipientOptions] = useState([]);
  const [selectedRecipients, setSelectedRecipients] = useState([]);
  const searchCls = useRef(null);

  const animatedComponents = makeAnimated();

  const errorsObj = { recipients: "" };
  const [errors, setErrors] = useState(errorsObj);

  const handleFocus = () => {
    if (recipientOptions.length === 0) {
      getRecipientList()
        .then((response) => {
          const data = response?.data?.data || [];
          const options = data.map((item) => ({
            value: item.email,
            label: `${item.first_name} ${item.last_name} (${item.email})`,
            ...item,
          }));
          setRecipientOptions(options);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  };

  const onSave = (e) => {
    e.preventDefault();
    let errorObj = { ...errorsObj };
    let error = false;

    if (selectedRecipients.length === 0) {
      errorObj.recipients = "Please select at least one collaborator.";
      error = true;
    }

    setErrors(errorObj);
    if (error) return;

    const newRecipients = selectedRecipients.map((r) => ({
      id: r.id,
      first_name: r.first_name,
      last_name: r.last_name,
      email: r.email,
    }));

    let formData = { ...props.formObj };
    const existingEmails = formData.recipient_List.map((r) => r.email);
    const uniqueRecipients = newRecipients.filter(
      (r) => !existingEmails.includes(r.email)
    );

    if (uniqueRecipients.length === 0) {
      toast.info("All selected collaborators are already added.");
      return;
    }

    formData.recipient_List = [...formData.recipient_List, ...uniqueRecipients];
    props.setFormObj(formData);

    toast.success("Collaborators added successfully.");
    clearData();
    searchCls.current?.click();
  };

  const clearData = () => {
    setSelectedRecipients([]);
    setErrors(errorsObj);
  };

  const onClose = (e) => {
    e.preventDefault();
    clearData();
    searchCls.current?.click();
  };

  return (
    <div
      className="offcanvas offcanvas-end Add-Recipients"
      data-bs-scroll="true"
      tabIndex="-1"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      id="SearchRecipients"
      aria-labelledby="SearchRecipientsLabel"
    >
      {/* Header */}
      <div className="offcanvas-header">
        <h5 className="offcanvas-title" id="notification_boxLabel">
          Add Collaborator
        </h5>
        <button
          type="button"
          className="btn close_btn text-reset"
          data-bs-dismiss="offcanvas"
          onClick={onClose}
          ref={searchCls}
          aria-label="Close"
        >
          <i className="bi bi-x-circle" aria-hidden="true" />
        </button>
      </div>

      {/* Body */}
      <div className="offcanvas-body">
        <div className="mx-3">
          {/* Recipient Dropdown */}
          <div className="mb-4">
            <label className="form-label mb-2">
              Select Collaborators
              <i
                className="bi bi-question-circle-fill ms-2"
                title="Click to see all collaborators or type to filter"
              />
            </label>

            <Select
              closeMenuOnSelect={false}
              isMulti
              options={recipientOptions}
              components={animatedComponents}
              value={selectedRecipients}
              onChange={(val) => setSelectedRecipients(val)}
              onFocus={handleFocus}
              placeholder="Click or type to select collaborators..."
            />

            {errors.recipients && (
              <div className="text-danger mt-2">{errors.recipients}</div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer py-2 border-2 border-top">
          <button type="button" onClick={onClose} className="btn btn-outline-secondary">
            Cancel
          </button>
          <button type="button" onClick={onSave} className="btn btn-primary">
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default SearchRecipient;
